<template>
  <v-container class="contenedor_principal">
    <Loader :esActiva="mostrar_loader"/>
    <v-container class="continer_recuperar">
      <form :style="{ 'margin-top': `${alturatotal}%` }" onsubmit="return false;">
        <p
          class="txt_indicaciones"
        >
        Introduzca su correo electrónico o teléfono que utilizó para crear su cuenta y le enviaremos 
        un código de verificación para restablecer su contraseña.
        <v-text-field 
          label="CORREO ELECTRÓNICO / CELULAR"
          solo
          class="pt-3"
          prepend-inner-icon="mdi-email-outline" 
          v-model="texto"
          v-on:keyup.enter="submit('verificar')" 
          ></v-text-field>
        <p style="color:red; font-size:13px;">{{text_error}}</p>
      </form>
    </v-container>

    <v-footer absolute class="font-weight-medium" padless>
      <v-btn x-large color="#58C4B5" dark style="width: 100%;" @click="submit('verificar')">ENVIAR</v-btn>
    </v-footer>
  </v-container>
</template>

<script>
import Vista from "@/objetos/vista";
import Conexion_api from "@/api/Conexion_api.js";
import Loader from '@/components/Loader/Loader.vue';
import Usuario from "@/objetos/usuario";

export default {
  data: () => ({
    alert: true,
    texto: "",
    text_error: "",
    mostrar_loader: false,
    usuario: Usuario
  }),
  components: {
    Loader
  },  
  mounted() {
    Vista.nombre = "/recuperar";
    this.$root.$emit("finaliza_cronometro", true);
  },
  computed:{
    alturatotal () {
      let dimension;
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': 
          dimension = '-30'
        break;
        case 'sm': 
          dimension ='-20'
        break
        case 'md': 
          dimension = '-10'
        break
        case 'lg': 
          dimension = '-5'
        break;
        case 'xl':
          dimension = '-3'
        break;
      }
      return dimension
    } 
  },
  watch: {
    texto(val) {
      if (!isNaN(val) &&  val.length < 9 ) {
        // Definir alguna validacion de número telefonico
        // estandar o por cada país      
        this.text_error = "El CELULAR debe tener mínimo 9 dígitos";
        return;
      }  else if(!isNaN(val) &&  val.length >= 9) {
        this.text_error = "";
        return
      }      
      //eslint-disable-next-line
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val))
        this.text_error = "Debe ser un email valido. (ejemplo@mail.com)";
      else this.text_error = "";
    }
  },
  methods: {
    submit() {
      if (!this.texto || this.text_error) {
        this.text_error = "EMAIL/CELULAR es requerido.";
        return;
      }
      this.mostrar_loader = true;
      this.generar_datos()
      Conexion_api({
        body: {
          ...this.usuario
        },
        evento: "login/recuperar_usuario"
      })
      .then(respuesta => {
          this.mostrar_loader = false;
          if (respuesta.data.error) {
            console.error(respuesta.data.error);
            this.$root.$emit('snackbar',{ color:"error", texto: respuesta.data.error})   
            return;
          } else if (respuesta.data.exito) {
            Usuario.recuperar = true
            Usuario.correo = respuesta.data.usuario.correo
            Usuario.validacion = respuesta.data.usuario.validacion
            Usuario.telefono = respuesta.data.usuario.telefono
            Usuario.nombre =respuesta.data.usuario.nombre,
            Usuario.rut =respuesta.data.usuario.rut,            
            Usuario.direccion =respuesta.data.usuario.direccion,
            Usuario.coordenadas =respuesta.data.usuario.coordenadas,
            Usuario.valido = true,
            Usuario.tiempo_sesion = 60,
            this.usuario = respuesta.data.usuario;
            this.$root.$emit('snackbar',{ 
              color:"green",
              texto: "Se le ha sido enviado  un código de verificación." })   
            this.$router.push("/verificar")
          }
        })
        .catch(err => {
          this.mostrar_loader = false;
          err = String(err);
          if(err.includes("Not Found"))
            this.$root.$emit('snackbar',{
              color:"error",
              texto: "No se puede completar la solicitud vuelve a intentarlo mas tarde." })
          console.error(err);
        });
    },
    clear() {
      this.$v.$reset();
    },
    generar_datos() {
       this.usuario.correo = ""
      //eslint-disable-next-line
      if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.texto)){ 
        this.usuario.correo = this.texto
        this.usuario.validacion = "correo"
      }
      if(!isNaN(this.texto)){
        this.usuario.telefono = this.texto
        this.usuario.validacion = "sms"
      }
    }
  }
};
</script>

<style scoped>
.contenedor_principal {
  display: table;
  height: 100%;
}
.continer_recuperar {
  border-radius: 10px;
  margin-top: 12%;
  width: 100%;
  display: table-cell;
  vertical-align: middle;
}
.txt_indicaciones {
  text-align: center;
  color: #515c6f;
  font-size: 15px;
}
</style>